import { contains } from 'ramda';

export default contains;
